import { useBCMSWorkflowStep } from "../../components/BCMSWorkflow/main.jsx";

export default class BCMSWorkflowStep {
    _workflow;
    _model;
    _globalController;
    _getStepState;
    _setStepState;
    _currentStep;
    _defaultState;
    
    constructor(defaultValue, steps, controller, workflow, navigate, stepState, setStepState) {
        this.navigate = navigate;
        this.model = controller.state;
        this.globalController = controller;
        this.getStepState = stepState;
        this.setStepState = setStepState;
        this.workflow = workflow;
        this.currentStep = useBCMSWorkflowStep(steps);
        this.defaultState = defaultValue;
    }

    // Setter for the workflow property
    set workflow(value) { this._workflow = value; }
    // Setter for the model property
    set model(value) { this._model = value; }
    // Setter for the globalDispatcher property
    set globalController(value) { this._globalController = value; }
    // Setter for the getStepState property
    set getStepState(value) { this._getStepState = value; }
    // Setter for the setStepState property
    set setStepState(value) { this._setStepState = value; }
    // Setter for the currentStep property
    set currentStep(value) { this._currentStep = value; }
    // Setter for the defaultState property
    set defaultState(value) { this._defaultState = value; }

    // Getter for the workflow property
    get workflow() { return this._workflow; }
    // Getter for the model property
    get model() { return this._model; }
    // Getter for the globalDispatcher property
    get globalController() { return this._globalController; }
    // Getter for the getStepState property
    get getStepState() { return this._getStepState; }
    // Getter for the setStepState property
    get setStepState() { return this._setStepState; }
    // Getter for the currentStep property
    get currentStep() { return this._currentStep; }
    // Getter for the defaultState property
    get defaultState() { return this._defaultState; }

    // update :: [STRING], STRING, * -> VOID
    // Update a property of the getStepState
    update(props, value) {
        let properties = props;

        (function setData(data){
            const currentProp = properties[0];
            properties = properties.slice(1);

            if(properties.length > 0) { setData(data[currentProp]); }
            else{ data[currentProp] = value; }
        })(this._getStepState);

        this._setStepState({ ...this._getStepState });
    }

    // read :: STRING -> *
    // Return the value from the getStepState object based on the passed name
    read(name) {
        return this._getStepState[name];
    }
}